import { Component, Vue } from 'vue-property-decorator'
import _com from "../../../assets/js/common";

@Component
export default class luckDialog extends Vue {
    get luckArr(){
        let luck = this.$store.getters["refresh/getLuck"];
        console.log('luck', luck.id, luck.winners)
        return luck.winners || [];
    }
    get luckHistory() {
		let history = this.$store.getters["refresh/getLuckHistory"];
		return history;
	}
    get roomData() {//房间数据
        return this.$store.getters["getRoomDetail/getRoomDetail"];
    }
    mounted() {
        if(this.$route.name == 'luckDialog'){
            this.getRecommendAsync();
        }
	}
    viewCoupon() {
        // 
        location.href = "//m" + this.domain + "/muser/coupon/list?orderStatus=0";
    }
    close(){
        this.$store.dispatch('refresh/setIsShowPrizeAsync',false);
        this.$store.dispatch('refresh/setIsFirstPrizeAsync',false);
    }

    getRecommendAsync(){
        this.$store.dispatch("refresh/getRecommendAsync", {
            roomNumber:this.$route.params.roomNumber,
            source:this.$route.params.source || this.source}
        );
    }

}
